import { render, staticRenderFns } from "./SingleCover.vue?vue&type=template&id=5d4237cd&scoped=true"
import script from "./SingleCover.vue?vue&type=script&lang=ts"
export * from "./SingleCover.vue?vue&type=script&lang=ts"
import style0 from "./SingleCover.vue?vue&type=style&index=0&id=5d4237cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4237cd",
  null
  
)

export default component.exports